import * as types from '../mutation-types'
import * as api from '../api'
import router from '../../router'
import moment from 'moment'

const state = {
  calendar_events: [],
  calendar_exception_data_for_date: {}
}

const getters = {
  allCalendarEvents: state => state.calendar_events,
  calendarExceptionDataForDate: state => state.calendar_exception_data_for_date
  // singleCalendarDayEvent: state => state.calendar_day_event
}

const actions = {
  getCalendarEvents ({ commit, rootGetters }, date) {
    let calendarEvents = []
    date = moment(date, 'YYYY-MM-DD')
    return api.instance.get('calendar_events/' + rootGetters.scopedSiteId + '/' + (date.month()) + '/' + date.year())
      .then(function (response) {
        calendarEvents = response.data.calendar_events
        commit(types.RECEIVE_CALENDAR_EVENTS, calendarEvents)
      })
  },
  getCalendarExceptionDataForDate ({ commit, rootGetters }, date) {
    date = moment(date, 'YYYY-MM-DD')
    return api.instance.get('calendar_exception_data_for_date/' + rootGetters.scopedSiteId + '/' + date.format('YYYY-MM-DD'))
      .then(function (response) {
        commit(types.RECEIVE_CALENDAR_EXCEPTION_DATA_FOR_DATE, response.data.calendar_exception_data_for_date)
      })
  },
  modifyExceptionRange ({ commit, rootGetters }, exceptionData) {
    exceptionData.day_schedule_ids = exceptionData.selected_day_schedules.map((daySchedule) => {
      return daySchedule.value
    })

    api.instance.post('calendar_exception_range/' + rootGetters.scopedSiteId, exceptionData)
      .then(function (response) {
        router.push({ name: 'CalendarScheduler' })
      })
  }
}

const mutations = {
  [types.RECEIVE_CALENDAR_EVENTS] (state, calendarEvents) {
    state.calendar_events = calendarEvents
  },
  [types.RECEIVE_CALENDAR_EXCEPTION_DATA_FOR_DATE] (state, calendarExceptionDataForDate) {
    state.calendar_exception_data_for_date = calendarExceptionDataForDate
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
